import { render, staticRenderFns } from "./UserBackoffice.vue?vue&type=template&id=b4f025a0&"
import script from "./UserBackoffice.vue?vue&type=script&lang=js&"
export * from "./UserBackoffice.vue?vue&type=script&lang=js&"
import style0 from "./UserBackoffice.vue?vue&type=style&index=0&id=b4f025a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports